/**
 * Handles chunk load errors that occur before React ErrorBoundary mounts.
 * E.g. when the initial route tries to lazy-load a component that 404s after deploy.
 */
function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const message = error.message.toLowerCase();
  return (
    message.includes("failed to fetch dynamically imported module") ||
    message.includes("loading chunk") ||
    message.includes("loading css chunk") ||
    message.includes("chunkloaderror") ||
    message.includes("importing a module script failed") ||
    message.includes("error loading dynamically imported module") ||
    error.name === "ChunkLoadError"
  );
}

function handleChunkError(): void {
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }
  const separator = window.location.search ? "&" : "?";
  window.location.href =
    window.location.origin +
    window.location.pathname +
    window.location.search +
    separator +
    "_refresh=" +
    Date.now();
}

export function setupChunkErrorHandler(): void {
  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) {
      event.preventDefault();
      console.warn("Chunk loading error (unhandled). Reloading page...");
      handleChunkError();
    }
  });
}
